<template>
    <basic-layout>
        <v-main>
            <v-container
              class="fill-height"
              fluid
            >
                <v-row
                  align="center"
                  justify="center"
                >
                    <v-col
                      cols="12"
                      sm="8"
                      md="6"
                      lg="4"
                      v-if="!loading"
                    >
                        <v-card v-if="!isLocal">
                            <v-card-text>
                                <p class="mt-3">Direct login is no longer supported. Please login using the <a href="https://storage360.storespace.com">Storage360 Portal</a> to access this application.</p>
                            </v-card-text>
                        </v-card>
                        <v-card class="elevation-12" v-else>
                            <v-toolbar dark>
                                <v-toolbar-title>Please Login to Continue</v-toolbar-title>
                            </v-toolbar>
                            <v-form
                              ref="loginForm"
                              @submit.prevent="handleLogin"
                            >
                                <v-card-text>
                                    <app-input
                                        data-testid="auth-login-email-input"
                                        class="auth-login-email-input"
                                        :type="'email'"
                                        :prepend-icon="'person'"
                                        v-model.trim="email"
                                        label="Email"
                                        :rules="{ required: true, email: true }"
                                        :useValidation="true"
                                    />
                                    <app-input
                                        data-testid="auth-login-password-input"
                                        class="auth-login-password-input"
                                        :type="'password'"
                                        :prepend-icon="'lock'"
                                        v-model.trim="password"
                                        label="Password"
                                        :rules="{ required: true }"
                                        :useValidation="true"
                                    />
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer />
                                    <v-btn
                                        data-testid="auth-login-btn"
                                        class="auth-login-btn"
                                        color="primary"
                                        type="submit"
                                    >
                                        Login
                                    </v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-col>
                    <div v-else>
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            :size="70"
                        />
                        <p class="mt-2">Logging in...</p>
                    </div>
                </v-row>
            </v-container>
            <v-snackbar
              color="error"
              right
              v-model="error"
            >
              {{ authErrorMessage }}
            </v-snackbar>
        </v-main>
    </basic-layout>
</template>

<script>
import AppInput from "@/components/global/AppInput";
import BasicLayout from "@/layouts/BasicLayout.vue";
import FormRules from "@/helpers/form-rules";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      email: "",
      emailRules: FormRules.emailRules,
      password: "",
      passwordRules: FormRules.passwordRules,
      error: false,
      loading: false,
      isLocal: process.env.VUE_APP_ALLOW_DIRECT_LOGIN === "true"
    };
  },
  methods: {
    handleLogin: function() {
      if (this.$refs.loginForm.validate()) {
        const { email, password } = this;
        this.$store.dispatch("loginRequest", { email, password })
          .then(() => {
            this.$router.push("/");
          })
          .catch(() => {
            this.error = true;
          });
      }
    }
  },
  computed: {
    ...mapGetters([
      "authStatus",
      "authErrorMessage"
    ])
  },
  components: {
    AppInput,
    BasicLayout
  },
  created() {
    const params = this.$route.query;

    if (params.accessToken && params.accessToken.length) {
      this.loading = true;

      this.$store.commit("ssoLogin", params);

      this.$store.dispatch("userRequest")
        .then(() => {
          this.$router.push("/");
        })
        .catch(() => {
          // handle SSO login error
        });
    }
  }
};
</script>
